import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {GameService} from "../../../services/game.service";
import {CarouselModel} from "../../../models/carousel.model";
import {Subscription} from "rxjs";
import {Game} from "../../../models/game.class";
import {CarouselBuilderService} from "../../../services/carousel-builder.service";

declare var bootstrap: any;


@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})

export class CarouselComponent implements OnChanges {

  @Input() dataList!: Game[];
  @Input() identifier!: string;

  title!: string;
  routerLink?: string;
  translateParam: string = "";

  favouriteIds: number[] = [];
  favouritesSubs?: Subscription;

  currentSlideIndex: number = 0;
  numOfSlides: number;
  carousels?: CarouselModel[];

  constructor(
    private carouselService: CarouselBuilderService,
    private gameService: GameService
  ) {
    this.numOfSlides = this.carouselService.numOfSlides;
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['dataList']) {
      if (this.dataList && this.dataList.length > 0) {
        switch (this.identifier) {
            case 'all':
              this.routerLink = ""
              this.title = "SELECTED_GAME.LINK_ALL"
              // this.translateParam = "";
              break;
            case 'provider': //more from the same provider
              let provider = this.gameService.providers.find(p=> this.dataList[0].publisher.toLowerCase().includes(p.name.toLowerCase()) )
              this.routerLink = `/providers/${provider ? provider.routerLink : this.dataList[0].publisher.toLowerCase()}`
              this.title = 'SELECTED_GAME.LINK_PROV'
              this.translateParam = `${provider ? provider.name : this.dataList[0].publisher}`
              break;
            // case 'live': //unnecessery - this is a default category - todo delete
            //     this.routerLink = "/games/live"
            //     this.title = 'CATEGORIES.LIVE'
            //   break;
            // case 'recent': //removed after refactoring categorisation
            //   this.routerLink = "/games/recent"
            //   this.title = "CATEGORIES.RECENT"
            //   break;
            case 'recommended-most-played':
              this.routerLink = "/games/recommended"
              this.title = "CATEGORIES.RECOMMENDED"
              break;
            case 'recommended-for-user':
              this.routerLink = "/games/recommended"
              this.title = "CATEGORIES.RECOMMENDED2"
              break;
            // case 'favourites': //removed after refactoring categorisation
            //   this.routerLink = "/games/favourites"
            //   this.title = "CATEGORIES.FAVOURITES"
            //   break;
            default:
              // let category = this.gameService.getCategoryToNavigate(this.identifier) //removed after refactoring categorisation
              // categories + recent, favourites
              this.routerLink = `/games/${this.identifier}`
              this.title = 'CATEGORIES.' + this.identifier.toUpperCase().replace('-', ""); //because of video-poker
              // this.translateParam = ""
              break;
          }
      }

      this.currentSlideIndex = 0;
      this.carousels = this.carouselService.buildCarousels(this.dataList)
    }
  }

  ngOnInit(){
      this.favouritesSubs = this.gameService.favouriteGameIds$.subscribe(ids => {
        this.favouriteIds = ids
      })
  }


  moveSlide(direction: 'prev' | 'next', size: string, identifier: string) {
    let carouselId = `carousel${size}${identifier.toUpperCase()}`;
    let myCarousel = document.getElementById(carouselId);

    if (myCarousel) {
      const bsCarousel = new bootstrap.Carousel(myCarousel);
      this.currentSlideIndex = direction === 'prev' ? this.currentSlideIndex - 1 : this.currentSlideIndex + 1;

      direction === 'next' ? bsCarousel.next() : bsCarousel.prev();
    }
  }

  isGame(item: Game | {}): boolean {
    //todo refactor this - remove it from template when we send valid games (top/new/from selected games and home causes problem)
    return item instanceof Game
  }


  //use placeholder when the image is not found
  updateNotFoundImgUrl(event: Event) {
    (event.target as HTMLImageElement).src = `https://placehold.co/512x512/3b3b3b/F0F0F0/png?text=${(event.target as HTMLImageElement).alt}`;
  }

  ngOnDestroy(){
    this.favouritesSubs?.unsubscribe()
  }

}


